const imgToolLogoDesk = document.getElementById("header-heading-logo-desktop");
const imgToolLogoMob = document.getElementById("header-heading-logo-mobile");
const imgElemDesk = document.getElementById("img-ferre-desktop");
const imgElemMob = document.getElementById("img-ferre-mobile");
const linkHome = document.getElementById("home-ferre");
const headerBg = document.getElementById("header-background");
const headerBgMobile = document.getElementById("header-background-mobile");
const textFerre = document.getElementById("text-ferre");
const telFerre = document.getElementById("tel-ferreteria");
const emailFerre = document.getElementById("email-ferreteria");
const whatsappHeader = document.getElementById("whatsapp-header");
const locationHeader = document.getElementById("location-header");
const footer = document.querySelector("footer");
const footerBtm = document.querySelector(".footer-btm");
const footerDireccion = document.getElementById("footer-direccion");
const footerContacto = document.getElementById("footer-contacto");
const footerLogo = document.getElementById("logo-footer");
const footerFbLogo = document.getElementById("footer-facebook-logo");
const footerInstaLogo = document.getElementById("footer-instagram-logo");
const textosFooter = document.querySelectorAll(
  `footer .content-description, 
  footer .menu-options ul li a, 
  footer .text-gral-footer, 
  footer .text-gral-footer a, 
  footer .menu-title, 
  footer .list-follow a,
  footer .footer-btm p`
);
const ferreteriasArray = [
  "ferretodo",
  "modelo",
  "modelo-de-pachuca",
  "santander",
  "xalostoc",
  "viejo",
];
const configuracionFerreterias = JSON.parse(
  document.getElementById("ferreterias-json").innerHTML
);

function setHeader(ferr) {
  if (!imgElemDesk || !imgElemMob) return;

  imgToolLogoDesk.srcset = configuracionFerreterias[ferr].header_tool_logo_img;
  imgToolLogoMob.src = configuracionFerreterias[ferr].header_tool_logo_img;
  imgElemDesk.src = configuracionFerreterias[ferr].header_logo_img;
  imgElemMob.src = configuracionFerreterias[ferr].header_logo_img;
  headerBg.style["background-color"] =
    configuracionFerreterias[ferr].header_background_color;
  headerBgMobile.style["background-color"] =
    configuracionFerreterias[ferr].header_background_color;
  whatsappHeader.style.color =
    configuracionFerreterias[ferr].header_text_logos_color;
  locationHeader.style.color =
    configuracionFerreterias[ferr].header_text_logos_color;
  linkHome.href = configuracionFerreterias[ferr].header_home_url;
  textFerre.style.color =
    configuracionFerreterias[ferr].header_text_logos_color;

  imgElemDesk.classList.remove("d-none");
  imgElemMob.classList.remove("d-none");
  textFerre.classList.remove("d-none");
}
function setFooter(ferr) {
  if (
    !footerContacto ||
    !footerDireccion ||
    !footerLogo ||
    !textosFooter ||
    !footer ||
    !footerBtm
  )
    return;

  footerLogo.srcset = configuracionFerreterias[ferr].footer_logo_img;
  if (configuracionFerreterias[ferr].footer_facebook_link)
    footerFbLogo.href = configuracionFerreterias[ferr].footer_facebook_link;
  else footerFbLogo.style.display = "none";
  if (configuracionFerreterias[ferr].footer_instagram_link)
    footerInstaLogo.href = configuracionFerreterias[ferr].footer_instagram_link;
  else footerInstaLogo.style.display = "none";
  
  footerDireccion.innerHTML =
    configuracionFerreterias[ferr].footer_direccion_html;
  footerContacto.innerHTML =
    configuracionFerreterias[ferr].footer_contacto_html;
  textosFooter?.forEach(
    (text) =>
      (text.style.color = configuracionFerreterias[ferr].footer_texts_color)
  );
  footer.style["background-color"] =
    configuracionFerreterias[ferr].footer_background_color;
  footer.style[
    "border-top"
  ] = `8px solid ${configuracionFerreterias[ferr].footer_lines_color}`;
  footerBtm.style[
    "border-top"
  ] = `1px solid ${configuracionFerreterias[ferr].footer_lines_color}`;
  footerBtm.style[
    "color"
  ] = `${configuracionFerreterias[ferr].footer_texts_color}`;
}

function setPhoneAndEmail(ferr) {
  if (!telFerre || !emailFerre || !whatsappHeader) return;

  telFerre.innerHTML = `<p>${configuracionFerreterias[ferr].header_whatsapp_number}</p>`;
  telFerre.style.color = configuracionFerreterias[ferr].header_text_logos_color;
  emailFerre.innerHTML = `<p>${configuracionFerreterias[ferr].header_email}</p>`;
  emailFerre.style.color =
    configuracionFerreterias[ferr].header_text_logos_color;
  whatsappHeader.href = configuracionFerreterias[ferr].header_whatsapp_url;
  locationHeader.href = configuracionFerreterias[ferr].header_location_url;
}

//página de sucursales
function setLocations(ferr) {
  if (!ferr) ferr = "tool";
  Array.from(document.querySelectorAll(".container-fluid[data-ferreteria]"))
    ?.filter((elem) => elem.dataset.ferreteria === ferr)
    ?.forEach((elem) => elem.classList.remove("d-none"));
}

const urlPath = window.location.pathname;
const urlParams = new URLSearchParams(window.location.search);
let ferr = "";

// Verifica si la URL es ferretodo.mx
if (window.location.host === 'ferretodo.mx') {
  // Lógica para establecer 'ferr' y guardar en sessionStorage
  ferr = 'ferretodo';  // O el valor que corresponda a 'ferretodo'
  window.sessionStorage.setItem('ferr', ferr);
  imgToolLogoMob.classList.add("d-none");
} 

else if (urlPath.includes("/pages/") && !window.sessionStorage.getItem("ferr")) {
  //regex para matchear con la parte después de /pages/ o sea de /pages/asdf/productos/etc matchea con asdf :)
  regexMatch = urlPath.match(/(?<=\/pages\/)[^?\/]+\??/);
  if (regexMatch) ferr = regexMatch[0];
  if (!ferreteriasArray.includes(ferr)) ferr = "";
  if (ferr) window.sessionStorage.setItem("ferr", ferr);
} else if (urlParams.has("id")) {
  ferr = urlParams.get("id");
  if (ferr == "ferreteria-viejo") ferr = "viejo";
  window.sessionStorage.setItem("ferr", ferr);
} else {
  ferr = window.sessionStorage.getItem("ferr");
}
console.log("ferr", ferr);
if (!ferr) ferr = "";
if (ferr) {
  setHeader(ferr);
  setPhoneAndEmail(ferr);
  setFooter(ferr);
}
setLocations(ferr);
